export default "__VITE_ASSET__qchl7Xqb__"